import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchLogin = async (body) => {
  const method = "POST";
  const response = await ApiRequestInterceptor(USERS.login, method, body);

  const token = response?.data?.token || response?.token;

  if ((response.code === 200 || response.statusCode === 200) && token) {
    localStorage.setItem("logindata", JSON.stringify({ data: { token } }));
    window.dispatchEvent(new Event("authChange"));
  } else {
    const errorMessage =
      response?.data?.error || response?.error || "Error desconocido";
    throw new Error(errorMessage);
  }
};